import { useNavigate, Link, useLocation, matchPath } from "react-router-dom"
import { useState, useEffect } from "react"

import { postApiHelper } from "../util/apiHelpers"
import useAuth from "../Hooks/useAuth"
import Settings from "./Settings"
// Images
import logo from "../assets/logos/logo.png"

function SecondNavbar() {
  const [userData, setUserData] = useState({})
  const history = useNavigate()
  const { pathname } = useLocation()
  const pathP = { path: "/performance" }
  const currentPathP = matchPath(pathP, pathname)
  const pathA = { path: "/target-market/audience-builder" }
  const currentPathA = matchPath(pathA, pathname)
  const pathC = { path: "/target-market/customer-builder" }
  const currentPathC = matchPath(pathC, pathname)
  const pathU = { path: "/target-market/user-builds" }
  const currentPathU = matchPath(pathU, pathname)
  const pathG = { path: "/target-market/global-builds" }
  const currentPathG = matchPath(pathG, pathname)
  const pathD = { path: "/target-market/dealer-builds" }
  const currentPathD = matchPath(pathD, pathname)
  const pathCampaigns = { path: "/target-market/campaigns" }
  const currentPathCampaigns = matchPath(pathCampaigns, pathname)
  const pathE = { path: "/inventory/inventory-builder" }
  const pathF = { path: "/inventory/budget" }
  const pathJ = { path: "/inventory/xxxx" }
  const pathH = { path: "/inventory/sold-table" }
  const pathI = { path: "/inventory/view-inventory-builds" }
  const pathS = { path: "/inventory/summary" }
  const pathIrr = { path: "/inventory/irregular" }
  const currentPathE = matchPath(pathE, pathname)
  const currentPathF = matchPath(pathF, pathname)
  const currentPathJ = matchPath(pathJ, pathname)
  const currentPathH = matchPath(pathH, pathname)
  const currentPathI = matchPath(pathI, pathname)
  const currentPathS = matchPath(pathS, pathname)
  const currentPathIrr = matchPath(pathIrr, pathname)
  const authPermRols = useAuth(
    [""],
    false,
    ["super-admin", "admin", "Management", "Staff"],
    true
  )

  const logOut = () => {
    postApiHelper(`Logout?userId=${userData.userID}`).then(() => {
      localStorage.removeItem("tokenDealerOMG")
      localStorage.removeItem("permissionsDealerOMG")
      history("/login")
    })
  }

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("permissionsDealerOMG")))
  }, [])

  return (
    <div className="mt-2 w-full flex flex-row justify-between items-center">
      <Link to="/">
        <img
          className="h-[auto] w-[275px] cursor-pointer"
          src={logo}
          alt="Dealer OMG Logo"
        />
      </Link>
      <div>
        <ul className="flex">
          <li
            className={`mr-6 rounded-md p-2 ${
              currentPathP?.pathname === "/performance" &&
              "active bg-[#E57200] font-bold"
            }`}
          >
            <Link to="/performance" className="text-white">
              PERFORMANCE
            </Link>
          </li>
          <li
            className={`mr-6 rounded-md p-2 ${
              (currentPathA?.pathname === "/target-market/audience-builder" ||
                currentPathC?.pathname === "/target-market/customer-builder" ||
                currentPathG?.pathname === "/target-market/global-builds" ||
                currentPathD?.pathname === "/target-market/dealer-builds" ||
                currentPathCampaigns?.pathname === "/target-market/campaigns" ||
                currentPathU?.pathname === "/target-market/user-builds") &&
              "active bg-[#E57200] font-bold"
            }`}
          >
            <Link to="/target-market/audience-builder" className="text-white">
              TARGET MARKET
            </Link>
          </li>
          <li className="mr-6 rounded-md p-2 text-white">OPPORTUNITY</li>
          <li
            className={`mr-6 rounded-md p-2 ${
              (currentPathE?.pathname === "/inventory/inventory-builder" ||
                currentPathI?.pathname === "/inventory/view-inventory-builds" ||
                currentPathF?.pathname === "/inventory/budget" ||
                currentPathJ?.pathname === "/inventory/xxxx" ||
                currentPathH?.pathname === "/inventory/sold-table" ||
                currentPathS?.pathname === "/inventory/summary" ||
                currentPathIrr?.pathname === "/inventory/irregular") &&
              "active bg-[#E57200] font-bold"
            }`}
          >
            <Link to="/inventory/inventory-builder" className="text-white">
              INVENTORY
            </Link>
          </li>
        </ul>
      </div>
      <div className="w-auto flex flex-row justify-end space-x-8 items-center">
        <p className="font-bold">
          {userData.firstName} {userData.lastName}
        </p>
        {authPermRols[2] ? <Settings top="75px" /> : null}
        <button
          onClick={logOut}
          className="flex flex-row justify-between text-white bg-[#E57200] focus:ring-4 font-bold rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
        >
          Log Out
        </button>
      </div>
    </div>
  )
}

export default SecondNavbar
